'use strict';

angular.module('licensure.portal')
    .directive('portalNavigation', ['$rootScope', 'PortalPermissions', function ($rootScope, PortalPermissions) {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'components/navigation/navigation.html',
            controller: ['$q', '$scope', 'Account', 'Authentication', 'Enterprise', '$state', '$rootScope', function ($q, $scope, Account, Authentication, Enterprise, $state, $rootScope) {
                $scope.loggedIn = false;
                $scope.pages = [];
                $scope.permissions = [];
                $scope.loadingMenu = true;
                $scope.examsModuleOn = false;
                $scope.inspectionsModuleOn = false;
                $scope.clinicianImportOn = false;
                $scope.manageRoute = null;
                $scope.loadingRoute = true;

                $scope.getEnterprise = function () {
                    const nonAuthStates = ['portal.menus.login', 'portal.menus.createaccount', 'portal.menus.forgotusername', 'portal.menus.forgotpassword', 'portal.menus.oidcLogin', 'portal.menus.oidcCallback'];
                    $rootScope.loadingEnterprise = true;

                    if ($rootScope.userAccount !== null && $state.from && ($state.from.name === '' || $state.from.name === 'portal.menus.login') && $state.current && !nonAuthStates.includes($state.current.name)) {
                        Enterprise.get().then(function (enterprise) {
                            if (enterprise != null) {
                                $rootScope.enterprise = enterprise;
                                $scope.educationModuleOn = (enterprise.education_module == null ? false : enterprise.education_module);
                                $scope.examsModuleOn = (enterprise.exams_module == null ? false : enterprise.exams_module);
                                $scope.inspectionsModuleOn = (enterprise.inspections_module == null ? false : enterprise.inspections_module);
                                $scope.clinicianImportOn = (enterprise.clinicians_import == null ? false : enterprise.clinicians_import);
                                $scope.voucherPayOn = (enterprise.settings.voucher_pay == null ? false : enterprise.settings.voucher_pay);
                                $scope.hideComplaints = (enterprise.hide_complaints == null ? false : enterprise.hide_complaints);
                            }
                            if ($rootScope.userAccount != null) {
                                if ($scope.examsModuleOn && $scope.getPermission('portal.menus.examsManageSessions') && ($rootScope.userAccount.exam_examiner || $rootScope.userAccount.exam_coordinator || $rootScope.userAccount.super)) {
                                    $scope.manageRoute = "portal.menus.examsManageSessions"
                                } else if ($scope.educationModuleOn && $scope.getPermission('portal.menus.educationManageCourses') && ($rootScope.userAccount.education_coordinator || $rootScope.userAccount.education_instructor || $rootScope.userAccount.super || $rootScope.userAccount.medical_director || $rootScope.userAccount.service_director)) {
                                    $scope.manageRoute = "portal.menus.educationManageCourses"
                                }
                            }
                            $scope.loadingRoute = false;
                            $rootScope.loadingEnterprise = false;
                        });
                    } else {
                        Enterprise.getLess({ isPortal: true }).then(function (enterprise) {
                            if (enterprise != null) {
                                $scope.educationModuleOn = (enterprise.education_module == null ? false : enterprise.education_module);
                                $scope.examsModuleOn = (enterprise.exams_module == null ? false : enterprise.exams_module);
                                $scope.inspectionsModuleOn = (enterprise.inspections_module == null ? false : enterprise.inspections_module);
                                $scope.clinicianImportOn = (enterprise.clinicians_import == null ? false : enterprise.clinicians_import);
                                $scope.voucherPayOn = (enterprise.settings.voucher_pay == null ? false : enterprise.settings.voucher_pay);
                                $scope.hideComplaints = (enterprise.hide_complaints == null ? false : enterprise.hide_complaints);
                            }
                            if ($rootScope.userAccount != null) {
                                if ($scope.examsModuleOn && $scope.getPermission('portal.menus.examsManageSessions') && ($rootScope.userAccount.exam_examiner || $rootScope.userAccount.exam_coordinator || $rootScope.userAccount.super)) {
                                    $scope.manageRoute = "portal.menus.examsManageSessions"
                                } else if ($scope.educationModuleOn && $scope.getPermission('portal.menus.educationManageCourses') && ($rootScope.userAccount.education_coordinator || $rootScope.userAccount.education_instructor || $rootScope.userAccount.super || $rootScope.userAccount.medical_director || $rootScope.userAccount.service_director)) {
                                    $scope.manageRoute = "portal.menus.educationManageCourses"
                                }
                            }
                            $scope.loadingRoute = false;
                            $rootScope.loadingEnterprise = false;
                        });
                    }
                }
                $scope.setupPermissions = function () {
                    var promises = [];
                    if (isEmpty($scope.permissions)) {
                        promises.push(PortalPermissions.getPermissions().then(function (portalPermissions) {
                            $scope.permissions = portalPermissions;
                        }));
                    }

                    promises.push(Authentication.get(true).then(function (authData) {
                        if (authData) {
                            $scope.loggedIn = true;
                        }
                        else {
                            Account.get({ portal: true }).then(function (account) {
                                //Also using user account to check if logged in, since local storage might not be set when redirecting from .net
                                if (account) {
                                    $scope.loggedIn = true;
                                    $rootScope.userAccount = account;
                                }
                            });
                        }
                    }));
                    $scope.getEnterprise();
                    $q.all(promises).then(function () {
                        $scope.loadingMenu = false;
                    }).catch(function (response) {
                        // handle error
                    });  
                }
                $scope.setupPermissions();

                $scope.getAppCounts = function () {
                    if ($rootScope.userAccount != null && typeof ($rootScope.userAccount.counts_retrieved) != "undefined" && !$rootScope.userAccount.counts_retrieved) {
                        Account.getApplicationCounts({ userID: $rootScope.userID }).then(function (counts) {
                            $rootScope.userAccount.counts_retrieved = true;
                            $rootScope.userAccount.continue_count = counts.continue_count;
                            $rootScope.userAccount.review_count = counts.review_count;
                            $rootScope.userAccount.checkout_count = counts.checkout_count;
                        });
                    }
                }
                $scope.getAppCounts();

                $scope.getPermission = function (state) {
                    if (!isEmpty($scope.permissions) && $scope.permissions[state] !== undefined) {
                        return (($rootScope.userAccount != null && $rootScope.userAccount.super) || $scope.permissions[state].visible) && (($scope.loggedIn && $scope.permissions[state].required_login != false) || $scope.permissions[state].required_login != true);
                    }
                    return false;
                }
                
                $scope.$watch('$state.current.name', function (newValue, oldValue) {
                    if (newValue != 'portal.menus.login') {
                        if ($rootScope.userAccount == null) {
                            Account.get({ portal: true }).then(
                                function (account) {
                                    $rootScope.userAccount = account;
                                    $scope.getEnterprise();
                                    $scope.getAppCounts();
                                }
                            );
                        }
                        else {
                            $scope.getEnterprise();
                        }
                    }
                });
                
                $scope.educationRoute = null;
                $scope.getEducationPermission = function () {
                    if ($scope.getPermission('portal.menus.myEducationDashboard')) {
                        $scope.educationRoute = 'portal#/education/myEducationDashboard';
                    } else if ($scope.getPermission('portal.menus.educationFindCourses')) {
                        $scope.educationRoute = 'portal#/education/findcourses';
                    } else if ($scope.getPermission('portal.menus.educationMyCourses')) {
                        $scope.educationRoute = 'portal#/education/mycourses';
                    } else if ($scope.getPermission('portal.menus.educationMyReport')) {
                        $scope.educationRoute = 'portal#/education/myreports';
                    }
                    return $scope.educationRoute != null;
                }
                
                $scope.getName = function (state) {
                    if (!isEmpty($scope.permissions) && $scope.permissions[state] !== undefined) {
                        return $scope.permissions[state].name || null;
                    }
                    return null;
                }

                $scope.getLicenseName = function () {
                    if ($rootScope.enterprise && $rootScope.enterprise.settings && $rootScope.enterprise.settings.license_label) {
                        return $rootScope.enterprise.settings.license_label;
                    }
                    return null;
                }

                $scope.checkDocumentLoad = function () {
                    //if we are loading a document on the react side hide the menu and expand the view size to fill the entire space available.  We are doing this so we can use the same document page for all react document links.
                    if (typeof $state.params.path !== 'undefined' && $state.params.path.indexOf('openDocument') > 0) {
                        document.getElementById("licensureNavMenu").remove();
                        document.getElementById("licensureView").className = "col-sm-12 col-md-12";
                    }
                }
                $scope.checkDocumentLoad();
            }],
            replace: true,
            link: function (scope, elem, attrs, ctrl) {

                $rootScope.$on('$stateChangeSuccess',
                    function (event, toState, toParams, fromState, fromParams) {
                        scope.loggedIn = false;
                        scope.setupPermissions();
                    }
                );
                $rootScope.$on('AuthenticationFromSSO:finish', function () {
                    scope.setupPermissions();
                });
            }
        };
    }])
    ;